export const standardDetail = {
    path: '/standardDetail',
    name: 'standardDetail',
    title: ' 标准详情',
    component: () => import("../components/page/homePage/standardDetail"),
    meta: { title: '标准详情' },
}


// WEBPACK FOOTER //
// ./src/router/standardDetail.js